import React from 'react';
import { FilterFieldType } from './CustomFilter';
import { Button } from 'react-bootstrap';

interface StaticAdvancedOptionProps {
	field: FilterFieldType;
	advOption: FilterFieldType['advancedOptions'][number];
	activeFilters: { [key: string]: string[] };
	handleFilterSet: (field: FilterFieldType, option: { value: string }, isActive: boolean) => void;
}

const StaticAdvancedOption: React.FC<StaticAdvancedOptionProps> = ({ advOption, field, activeFilters, handleFilterSet }) => {
	return (
		<div
			style={{
				display: 'flex',
				flexWrap: 'wrap',
				gap: '1rem',
			}}
		>
			{advOption.options.map((option) => {
				const isActive = activeFilters[field.queryParamName]?.includes(option.value);
				return (
					<Button
						onClick={() => {
							handleFilterSet(field, option, isActive);
						}}
						key={option.value}
						className={`btn ${isActive ? 'custom-primary-button' : 'custom-outline-button'}`}
						style={{
							borderRadius: '20px',
							textTransform: 'none',
							fontWeight: 400,
						}}
					>
						{option.label}
					</Button>
				);
			})}
		</div>
	);
};

export default StaticAdvancedOption;
